import React from "react";
import { Song } from "../../types/song";
import SongHero from "./SongHero";
import EmbeddedPlayer from "./EmbeddedPlayer";
import ListenEverywhere from "./ListenEverywhere";
import BehindTheSong from "./BehindTheSong";
import MusicVideo from "./MusicVideo";
import Lyrics from "./Lyrics";
import ShareSong from "./ShareSong";
import ExploreMoreMusic from "./ExploreMoreMusic";

// Full song landing page composed of independently-hiding sections.
// Reused by /listen today and intended for a future /songs/:slug route.
interface SongLandingProps {
  song: Song;
}

const SongLanding: React.FC<SongLandingProps> = ({ song }) => (
  <>
    <SongHero song={song} />
    <EmbeddedPlayer song={song} />
    <ListenEverywhere song={song} />
    <BehindTheSong song={song} />
    <MusicVideo song={song} />
    <Lyrics song={song} />
    <ShareSong song={song} />
    <ExploreMoreMusic />
  </>
);

export default SongLanding;
